import React from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { CustomModal } from '../customModal';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setRenderWidgetInfoModal } from '../../Redux/Actions/appConfigAction';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';
import { getStyleForRenderHTML } from '../../js/utility';

const InfoModalWidget_Potrait = () => {
    const {width} = useWindowDimensions();

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { modalData } = useSelector(state => state.appConfigSlice.renderWidgetInfoModal);
    const widgetMetaHtmlId = modalData?.widgetMetaHtmlId;

    const handleClose = () => {
        dispatch(setRenderWidgetInfoModal(false));
    };

    const customGuestRequestHeaderTitleStyle = getStyles(['widgetInfoModalTitle', `widgetInfoModalTitle_${widgetMetaHtmlId}`]);
    const customGuestRequestTitleStyle = getStyles(['widgetInfoModalDescription', `widgetInfoModalDescription_${widgetMetaHtmlId}`]);

    const { baseStyle: titleHeaderBaseStyle, systemFonts: titleHeaderSystemFonts } = getStyleForRenderHTML(customGuestRequestHeaderTitleStyle);
    const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customGuestRequestTitleStyle);

    return (
        <CustomModal onRequestClose={handleClose}>
            <View style={getStyles(['widgetInfoModalContainer'])} id="widgetInfoModalContainer">
                {/* Header Image */}
                {modalData?.widgetHeaderImageUrl && (
                    <View style={getStyles(['widgetInfoModalImageWrapper'])} id="widgetInfoModalImageWrapper">
                        <ImageComp
                            source={getCleanUrl(modalData.widgetHeaderImageUrl)}
                            style={getStyles(['widgetInfoModalHeaderImage'])}
                            id="widgetInfoModalHeaderImage"
                        />
                    </View>
                )}

                {/* Close Button */}
                <CustomPressable
                    onPress={handleClose}
                    style={getStyles(['widgetInfoModalCloseBtn'])}
                    id="widgetInfoModalCloseBtn"
                >
                    <Text style={getStyles(['widgetInfoModalCloseBtnTxt'])} id="widgetInfoModalCloseBtnTxt">
                        ✕
                    </Text>
                </CustomPressable>

                {/* Content */}
                <View style={getStyles(['widgetInfoModalContent'])} id="widgetInfoModalContent">
                    {modalData?.contentTitle && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={titleHeaderBaseStyle}
                            source={{html: modalData?.contentTitle}}
                            systemFonts={titleHeaderSystemFonts}
                            id={`widgetInfoModalTitle`}
                        />
                    )}
                    {modalData?.contentDescription && (
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={titleBaseStyle}
                            source={{html: modalData?.contentDescription}}
                            systemFonts={titleSystemFonts}
                            id={`widgetInfoModalDescription`}
                        />
                    )}
                </View>
            </View>
        </CustomModal>
    );
};

export default InfoModalWidget_Potrait;
